import { render } from "./Max.vue?vue&type=template&id=46c99474"
import script from "./Max.vue?vue&type=script&setup=true&lang=js"
export * from "./Max.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Max.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c99474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c99474', __exports__)) {
    api.reload('46c99474', __exports__)
  }
  
  module.hot.accept("./Max.vue?vue&type=template&id=46c99474", () => {
    api.rerender('46c99474', render)
  })

}


export default __exports__